export const getCustomerApplicationApiUrl = (uid: string) =>
  new URL(`/me/customer-account/${uid}`, window.env.WEB_API_ROOT).toString();
